/**
 * 全局配置项
 *
 * */

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    maintainUrl: '//jiuqoss.oss-cn-shenzhen.aliyuncs.com/html/config/'+location.hostname+'.js',//是否升级维护

    api: window.gatewayUrl || '/api',

    headers: ['Authorization'], //加入请求头的当前数据字段

    cachePrefix: 'JQ_IOT_',  //缓存前缀

    platType: 20, //请求头的系统类型标识 10 电工， 30 物管， 20 运营

    currentType: 'WEB', //系统端类型

    userInfo: 'USERINFO', //缓存用户信息key

    userRoute: 'USERROUTE', //缓存用户信息key

    // 设备类型组件结构配置 - 节点类型
    nodeType: {
        GROUP: 'collectPointGroup',  //类型分组
        POINT: 'collectPoint',  //采集点
        GATEWAY: 'gateway',  //网关
        DEVICE: 'device',  //直连设备
        CHILD_DEVICE: 'childrenDevice',  //子设备/电表
        METER: 'METER',
        WATER: 'WATER',
    },


    // 分页配置项
    page: {
        size: 100, //默认加载多少条数据
        page: 0, // 当前页
    },

    // 导出时文件类型
    exportFileType: {
        xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        xls: 'application/vnd.ms-excel',
        pdf: 'application/pdf',
        zip: 'application/zip',
    },
}
